angular
    .module('webcomm')
    .controller('SettingsController', [
        '$rootScope',
        '$scope',
        '$log',
        'wtcpjsService',
        'settingsService',
        'channelModel',
        'profileModel',
        'audioService',
        function ($rootScope, $scope, $log, wtcpjsService, settingsService, channelModel, profileModel, audioService) {

            var selectedProfile = profileModel.getSelectedProfile();
            var channels = {};
            var initialVolume = $scope.volume = settingsService.getVolume();
            var channelIds = profileModel.getChannelIdsForProfile(selectedProfile.profileId);

            $scope.locationToggleOn = false;
            $scope.locationToggleDisabled = true;
            $scope.webcommVersion = window.webcomm_version;
            $scope.talkGroup = {
                showMaxMessage: channelIds.length > wtcpjsService.getMaxActiveChannelCount(),
                maxActiveChannels: wtcpjsService.getMaxActiveChannelCount(),
                selection: [],
                numSelected() { return this.selection.filter(s => s.active).length; },
                isSelectionValid() { return this.numSelected() <= this.maxActiveChannels;}
            };

            var copyChannels = () => {
                channelIds = profileModel.getChannelIdsForProfile(selectedProfile.profileId);
                angular.forEach(channelIds, (v, k) => {
                    channels[v] = channelModel.getChannel(v);
                    
                    $scope.talkGroup.selection.push({
                        'name': channels[v].name,
                        'active': channels[v].active,
                        'id': channels[v].id
                    });
                });
            };

            copyChannels();

            $scope.toggleLocation = function() {
                if ($scope.locationToggleDisabled === false) {
                    $scope.locationToggleOn ? $scope.locationToggleOn = false : $scope.locationToggleOn = true;
                }
            };

            $scope.enableToggle = function() {
                $scope.locationToggleDisabled = false;
                $scope.locationToggleOn = settingsService.shareLocation;
            };

            $scope.disableToggle = function() {
                $scope.locationToggleDisabled = true;
                $scope.locationToggleOn = false;
            };

            $scope.saveSettings = () => {
                let channelsChanged = false;
                for (let c of $scope.talkGroup.selection) {
                    if (channels[c.id].active !== c.active) {
                        channels[c.id].active = c.active;
                        channelsChanged = true;
                    }
                }

                settingsService.persistVolume($scope.volume);
                initialVolume = $scope.volume; // so we don't revert on 'closeSettings'
                settingsService.updateChannelSelection(channels);
                settingsService.shareLocation = $scope.locationToggleOn;
                if (channelsChanged) {
                    wtcpjsService.changeActiveChannels();
                    channelModel.selectFirstActiveChannel();
                }
                $scope.closeSettings();
            };

            $scope.closeSettings = function() {
                copyChannels();
                $scope.volume = initialVolume;
                audioService.adjustVolume($scope.volume);
                $scope.$emit("settings.close");
            };

            var unbindSlideEnded = $scope.$on("slideEnded", function() {
                audioService.adjustVolume($scope.volume);
            });

            $scope.enableToggle();

            $scope.$on("$destroy", function() {
                unbindSlideEnded();
            });
        }
    ]);